import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import { catalogSongMessages } from './catalogSongMessages';
import { PickedMasterFile } from './PickedMasterFile';
import { RightsConfirmRow } from './RightsConfirmRow';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the song files; each part uses its own slice of it */
import styles from './SongFiles.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PendingMasterConfirmProps {
  file: File;
  rightsChecked: boolean;
  onRightsChange: (checked: boolean) => void;
  onUpload: () => void;
  onCancel: () => void;
}

/** Design g1: the picked file waits for the rights box, then Upload sends it. */
const PendingMasterConfirmComponent: React.FC<PendingMasterConfirmProps> = ({
  file,
  rightsChecked,
  onRightsChange,
  onUpload,
  onCancel,
}) => {
  const intl = useIntl();

  return (
    <>
      <PickedMasterFile file={file} isWaitingForRights onRemove={onCancel} />
      <RightsConfirmRow checked={rightsChecked} onChange={onRightsChange} />
      <div className="d-flex align-items-center gap-3">
        <span className={styles.footNote}>{intl.formatMessage(catalogSongMessages.rightsNeeded)}</span>
        <SMLButton size="sm" color="primary" omitCap disabled={!rightsChecked} onClick={onUpload}>
          {intl.formatMessage(catalogSongMessages.upload)}
        </SMLButton>
      </div>
    </>
  );
};

export const PendingMasterConfirm = TypedMemo(PendingMasterConfirmComponent);
